import type { RouteRecordRaw } from "vue-router";

// School-class invite redemption flow.
//
// The teacher invite card (#9813/#9819) builds shareable links of the form
// `${origin}/school_class_invites/:code`. This route renders the redemption
// overlay (#9816, licence happy path). The no-licence (#9944) and expired-link
// (#9945) states are layered on top of the same page later.
export const schoolClassInvitesRoutes: RouteRecordRaw[] = [
  {
    path: "/school_class_invites/:code",
    name: "school_class_invite_redeem",
    component: () => import("./SchoolClassInviteRedeemPage.vue"),
    meta: {
      requiresTeacher: true,
    },
  },
];
